import { createContext, useContext } from 'react'

export const PedidoContext = createContext(null);

export const usePedidoContext = () => {
	return useContext(PedidoContext);
}